<template>
  <div class="allocation-chart" data-testid="allocation-chart">
    <DonutChart
      :data-set="dataSet"
      :is-loading="isLoading"
      :has-error="hasError"
      :border-color="NebraskaColors.backgroundPrimary"
      @hover-allocation="onHoverAllocation"
      @on-error-click="emitOnRetry"
    >
      <template v-if="!isLoading && !hasError">
        <ChartSummary v-bind="chartSummaryData" />
      </template>
    </DonutChart>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { DonutChart } from '@warrenbrasil/nebraska-web';
import { ChartSummary } from './components/ChartSummary';

import { PortfolioSection } from '@/modules/wealth/services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  sections: PortfolioSection[];
  totalBalance?: string;
  updatedAt?: string;
  isLoading: boolean;
  hasError: boolean;
}
const props = defineProps<Props>();

interface Emits {
  (e: 'on-retry'): void;
}
const emit = defineEmits<Emits>();

const selectedSectionIndex = ref<number | null>(null);

const dataSet = computed(() => {
  return props.sections.map(section => ({
    name: section.name,
    color: section.color,
    y: section.balance.value
  }));
});

const chartSummaryData = computed(() => {
  if (selectedSectionIndex.value === null) {
    return {
      head: 'Total alocado',
      title: props.totalBalance,
      subtitle: props.updatedAt
    };
  }

  const sectionSelected = props.sections[selectedSectionIndex.value];

  return {
    head: 'Total alocado',
    title: sectionSelected.balance.formatted,
    subtitle: sectionSelected.name
  };
});

const emitOnRetry = () => {
  emit('on-retry');
};

const onHoverAllocation = (index: number | null) => {
  selectedSectionIndex.value = index;
};
</script>

<style lang="less" scoped>
.allocation-chart {
  background-color: @background-primary;
  border-radius: @size-radius-x200;
  padding: @size-spacing-x600 0;
}
</style>
